import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export const signupSchema = Yup.object({
  businessName: Yup.string()
    .min(2)
    .max(20)
    .required('Please enter business name'),
  email: Yup.string().email().required('Please enter your email'),
  password: Yup.string()
    .min(6)
    .max(30)
    .required('Please enter your password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
  passwordConfirm: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Password must match'),
  terms: Yup.boolean().oneOf(
    [true],
    'You must accept the terms and conditions'
  ),
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string().email().required('Please enter your email'),
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string()
    .min(6)
    .max(30)
    .required('Please enter your password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
  passwordConfirm: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Password must match'),
});

// Step 1: Create Account validation schema
export const createAccountSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
  terms: Yup.boolean()
    .oneOf([true], 'You must accept the terms and conditions')
    .required('You must accept the terms and conditions'),
  accountType: Yup.string()
    .oneOf(['trial', 'prod'], 'Select Trial or Production')
    .required('Account type is required'),
});

// Step 2: Profile & Business Info validation schema
export const profileBusinessInfoSchema = Yup.object({
  fullName: Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters')
    .required('Full name is required'),
  businessName: Yup.string()
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be less than 100 characters')
    .required('Business name is required'),
});

// Step 3: Registered Location validation schema
export const registeredLocationSchema = Yup.object({
  registeredAddress: Yup.string()
    .min(5, 'Address must be at least 5 characters')
    .max(200, 'Address must be less than 200 characters')
    .required('Registered address is required'),
});

/** User profile page (GET /me fields; save API to be wired later) */
export const userProfileSchema = Yup.object({
  name: Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters')
    .required('Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  businessName: Yup.string()
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be less than 100 characters')
    .required('Business name is required'),
  accountType: Yup.string()
    .oneOf(['trial', 'prod'], 'Select Trial or Production')
    .required('Account type is required'),
});
